import React, { useEffect, useState, useContext  } from "react"
import Flatpickr from "react-flatpickr";

import { Input, InputGroup, Form, FormFeedback, Button, CardFooter } from "reactstrap"
import { Col, Row, Card, CardBody, Container, Label } from "reactstrap"
import Select from "react-select"
import CreatableSelect from "react-select/creatable"
import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import { CreatePdpa, GetPdpaById, UpdatePdpa } from "services/api/module/Pdpa"
import ModalContext from "../../contexts/ModalContext";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import { SavePageDetail, SearchPageSetting, UpdatePageDetail } from "services/api/module/PageSetting";
import configWebRoute from "services/api/configWebRoute";
import { CreatePageDetailSetting2, UpdatePageDetailSetting2 } from "services/api/module/PageDetailSetting2";
import { slugify } from "helpers/fn_helper";
import InputText from "components/Input/InputText";
import Error401 from "components/Error401";

const wr = configWebRoute
const _parentComponent = wr.PRIVACY_NOTICE_KEY
const _routePermission = `pdpa:page`


const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const PrivacyNoticeTemplate = ({
  pageView = "create",
  keyId = null,
  componentKey = "",
  pageName = ''
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext);

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? 'TH'
  const qMainId = qParams.id
  const qCustomKey = keyId ? { fieldName: 'policyType', value: keyId } : {}
  const navigate = useNavigate();
  const [pageType, setPageType] = useState("link-out")
  const [contentType, setContentType] = useState("html")

  const isLinkOut = pageType === "link-out"

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    contentPageName: Yup.string().required("Please Enter Page Name"),
    slug: Yup.string().max(255).required("Please Enter Slug"),
    contentSubject: Yup.string().max(255).required("Please Enter หัวข้อ"),
    contentDetail: isLinkOut === false
        ? Yup.string().required("Please Enter รายละเอียด")
        : Yup.string(),

    contentLinks: isLinkOut 
    ? Yup.array().of(
        Yup.object().shape({
            attachmentTitle: Yup.string().max(255).required("Please Enter Attachment Title"),
            attachmentAlt: Yup.string().max(255).required("Please Enter Attachment Alt"),
        })
    )
    : Yup.array(),

    bannerDesktop: Yup.object().when('pageType', (pageType = '') => {
        return Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner Desktop",
            (value) => value && Object.keys(value).length > 0
        ).required()
            
    }),

    bannerMobile: Yup.object().when('pageType', (pageType = '') => {
        return Yup.object().test(
            "is-not-empty-object",
            "Please Upload Banner Mobile",
            (value) => value && Object.keys(value).length > 0
        ).required()
    }),

    contentSeoTitle: Yup.string().required("Please Enter Meta Title"),
    // contentSeoKeyword: Yup.string().max(1024).required("Please Enter Meta keyword"),
    // contentSeoDescription: Yup.string().max(1024).required("Please Enter Meta Description"),
    contentUpdateDate: Yup.string().max(100).required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),

    contentType: isLinkOut === false
            ? Yup.string().required("Please Enter Content Type")
            : Yup.string(),

  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)
  const [contentLoading, setContentLoading] = useState(false)

  const initialValues = {
    contentId: "",
    
    contentPageName: "",
    slug: "",
    // Content
    contentSubject: "",
    contentDetail: "",
    contentLinks: [
        {
            attachmentField: "links",
            attachmentName: "-",
            attachmentRawName: "-",
            attachmentType: "-",
            attachmentTitle: "",
            attachmentAlt: "",
            attachmentExtension: "0",
            attachmentSize: "0",
            attachmentStatus: "active",
        },
    ],
    contentFiles: [],

    bannerDesktop: {},
    bannerMobile: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format('YYYY-MM-DD'),
    contentStatus: "active",

    pageDetailSettingId: "",

    contentType: "html"
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ PdpaCreate ~ values:", values)
      const payload = {
        id: qMainId ? qMainId : undefined,
        contentId: values.contentId ? values.contentId: undefined,
        langId: qLang,
        pageType: pageType,

        contentSubject: values.contentSubject,
        contentDetail: values.contentDetail,

        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {
            
        },

        contentAttachmentData: {
          bannerDesktop: values.bannerDesktop,
          bannerMobile: values.bannerMobile,
          links: values.contentLinks,
          files: values.contentFiles,
        },

        contentType: contentType,
      };
      
      const pageDetailRoute = {
        mainId: values.pageDetailSettingId,
        slug: values.slug.replace(/-+$/, ''),
        contentPageName: values.contentPageName,
        attachmentData: {
            
        },
        contentAttachmentData: {
          bannerDesktop: values.bannerDesktop,
          bannerMobile: values.bannerMobile,
        },
        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        componentKey: componentKey,
        parentComponentKey: _parentComponent
      }
      console.log("🚀 ~ onSave ~ payload:", payload);
      console.log("🚀 ~ pageDetailRoute:", pageDetailRoute)

      if (pageView === "update") {
        API.fetchUpdatePdpa(payload, { ...qCustomKey }, pageDetailRoute)
      } else {
        API.fetchCreatePdpa(payload, pageDetailRoute)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)

    setPageType(resData?.pageType ?? "")
    setContentType(resData?.contentType ?? "")
    // resetForm(validation.values, initialValues)

    // validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
    // validation.setFieldValue("slug", resData?.slug ?? "")
    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentSubject", resData?.contentSubject ?? "")
    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue("contentFiles", resData?.contentFiles ?? [])
    validation.setFieldValue("contentLinks", resData?.contentLinks ?? [])

    validation.setFieldValue("bannerDesktop", resData?.contentBannerDesktop ?? {})
    validation.setFieldValue("bannerMobile", resData?.contentBannerMobile ?? {})
    
    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
    validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
    validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
    validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")




    validation.setFieldValue("pageDetailSettingId", resData?.pageDetailSettingId)

    if (resData?.pageDetailSetting) {
      validation.setFieldValue("contentPageName", resData?.pageDetailSetting.contentPageName ?? "")
      validation.setFieldValue("slug", resData?.pageDetailSetting.slug ?? "")
    }
  }

  const API = {
      fetchGetContentPageSetting: async (componentKey) => {
        try {
            const response = await SearchPageSetting(componentKey, {
                lang: qLang,
            })
            const resData = response.data
            if (resData.status == 200) {
                // preFilInput(resData.data)
            }
        } catch (err) {
            console.log("err ", err)
            mAlert.info({
                title: "Alert",
                subTitle: "Something went wrong 001",
                content: "",
                onClose: () => {
                    //  alert("onClose")
                },
            })
        } finally {
            setContentLoading(false)
        }
    },
    fetchGetPdpaById: async (payload) => {
      try {
          const response = await GetPdpaById({ id: payload.id, params: payload, lang: qLang })
          const resData = response.data
          if (resData.status == 200) {
            preFilInput(resData.data)
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
            title: "Alert",
            subTitle: "Something went wrong",
            content: "",
            onClose: () => {
            //  alert("onClose")
            },
        })
      }
    },
    fetchCreatePdpa: async (payload, pageDetailRoute) => {
      try {
          const responseP = await CreatePageDetailSetting2({ data: pageDetailRoute, lang: qLang })
          const resDataP = responseP.data
          
          const sumPayload = { ...payload, pageDetailSettingId: resDataP?.data?.mainId }
          const response = await CreatePdpa({ data: sumPayload, lang: qLang })
          const resData = response.data
          if (resData.status == 201) {
            mAlert.info({
                title: "Alert",
                subTitle: "Created Data Success",
                content: "",
                onClose: () => {
                  navigate(`/pdpa/privacy-notice/${qLang}`)
                },
            })
          }
      } catch (e) {
          console.log(e)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    },
    fetchUpdatePdpa: async (payload, params, pageDetailRoute) => {
      try {
          // const responseP = await UpdatePageDetail(componentKey, { data: pageDetailRoute, lang: qLang })
        const responseP = await UpdatePageDetailSetting2({ data: pageDetailRoute, id: pageDetailRoute.mainId, lang: qLang })
        const resDataP = responseP.data

          const response = await UpdatePdpa({ data: payload, id: payload.id, params: params, lang: qLang })
          const resData = response.data
          if (resData.status == 202) {
              mAlert.info({
                  title: "Alert",
                  subTitle: "Update Data Success",
                  content: "",
                  onClose: () => {
                      navigate(`/pdpa/privacy-notice/${qLang}`)
                  },
              })
          }
      }
      catch (err) {
          console.log('err ', err)
          mAlert.info({
              title: "Alert",
              subTitle: "Something went wrong",
              content: "",
              onClose: () => {
              //  alert("onClose")
              },
          })
      }
    }
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id : qMainId, ...qCustomKey }
      console.log("🚀 ~ useEffect ~ payload:", payload)
      API.fetchGetPdpaById(payload)
      API.fetchGetContentPageSetting(componentKey)
    }
  }, [qLang, keyId])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))

  let PAGE_NAME = 'PDPA'
  if (pageName) {
    PAGE_NAME = `${pageName}`.toUpperCase()
  }


  document.title = `${PAGE_NAME} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE



  if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
    return <Error401 />
    }

  
  
  return (
      <React.Fragment>
          <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumb */}
                <Breadcrumbs
                  title={`${PAGE_VIEW} ${PAGE_NAME}`}
                  breadcrumbItems={[
                    { title: `${PAGE_NAME}`, link: "" },
                    { title: PAGE_VIEW },
                  ]}
                />
    
                {/* Render Form */}
                <Row>
                  <Col className="col-12">
                  <FormikProvider value={validation}>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                      }}
                    >
                      <Row>
                        <Col className="col-8">
                            <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className='bx bx-cube-alt'></i> Information Box
                                </h5>
                                <CardBody>
                                <Row>
                                    <Col className="col-12 mb-3">
                                        <Label for="exampleSelect">
                                            Page Type
                                        </Label>
                                        <Input
                                            id="pageType"
                                            className="form-control"
                                            type="select"
                                            placeholder=""
                                            name="pageType"
                                            onChange={e => {
                                                setPageType(e.target.value)
                                                if (e.target.value === 'link-out') {
                                                    const def = [
                                                        {
                                                            attachmentField: "links",
                                                            attachmentName: "-",
                                                            attachmentRawName: "-",
                                                            attachmentType: "-",
                                                            attachmentTitle: "",
                                                            attachmentAlt: "",
                                                            attachmentExtension: "0",
                                                            attachmentSize: "0",
                                                            attachmentStatus: "active",
                                                        },
                                                    ]
                                                    validation.setFieldValue('contentLinks', def)
                                                } else {
                                                    validation.setFieldValue('contentLinks', [])
                                                }
                                            }}
                                            value={pageType}
                                            disabled={['update', 'view'].includes(pageView)}
                                        >
                                            <option value="link-out">Link Out</option>
                                            <option value="page">Page</option>
                                        </Input>
                                        {validation.touched.pageType && validation.errors.pageType && (
                                            <FormFeedback type="invalid">
                                                {validation.errors.pageType}
                                            </FormFeedback>
                                        )}
                                    </Col>
                                    <Col className="col-12 mb-3">
                                        <label
                                            htmlFor="contentPageName"
                                            className="col-md-12 col-form-label"
                                        >
                                            Page Name
                                            <span className="t-require">*</span>
                                        </label>
                                        <div className="col-md-12">
                                            <InputText
                                                id="contentPageName"
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                name="contentPageName"
                                                onChange={e => {
                                                    validation.setFieldValue("contentPageName", e.target.value)
                                                }}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.contentPageName}
                                                invalid={validation.touched.contentPageName && validation.errors.contentPageName ? true : false}
                                                disabled={pageView === "view"}
                                                maxLength={9999}
                                                errorText={validation.errors.contentPageName}
                                            />
                                        </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                        <label
                                            htmlFor="slug"
                                            className="col-md-12 col-form-label"
                                        >
                                            Slug
                                            <span className="t-require">*</span>
                                        </label>
                                        <div className="col-md-12">
                                            <InputText
                                                id="slug"
                                                className="form-control"
                                                type="text"
                                                placeholder=""
                                                name="slug"
                                                onChange={e => {
                                                    validation.setFieldValue("slug", slugify(e.target.value))
                                                }}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.slug}
                                                invalid={validation.touched.slug && validation.errors.slug ? true : false}
                                                disabled={pageView === "view"}
                                                maxLength={9999}
                                                errorText={validation.errors.slug}
                                            />
                                            
                                        </div>
                                        <hr />
                                    </Col>
                                    <Col className="col-12 mb-3">
                                        <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                        >
                                        หัวข้อ
                                        <span className="t-require">*</span>
                                        </label>
                                        <div className="col-md-12">
                                        <InputText
                                            id="contentSubject"
                                            className="form-control"
                                            type="text"
                                            placeholder=""
                                            name="contentSubject"
                                        
                                            onChange={(e) => {
                                            validation.setFieldValue("contentSubject", e.target.value)
                                            validation.setFieldValue("contentSeoTitle", e.target.value)
                                            }}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.contentSubject}
                                            invalid={validation.touched.contentSubject && validation.errors.contentSubject ? true : false}
                                            disabled={pageView === "view"}
                                            maxLength={9999}
                                            errorText={validation.errors.contentSubject}
                                        />
                                        </div>
                                    </Col>
                                    {
                                        isLinkOut === false 
                                        ? (
                                            <>
                                            <Col className="col-12 mb-3">
                                                <Label for="contentType">
                                                    Content Type
                                                </Label>
                                                <Input
                                                    id="contentType"
                                                    className="form-control"
                                                    type="select"
                                                    placeholder=""
                                                    name="contentType"
                                                    onChange={e => {
                                                        setContentType(e.target.value)
                                                        validation.setFieldValue(
                                                            "contentType",
                                                            e.target.value
                                                        )
                                                    }}
                                                    onBlur={validation.handleBlur}
                                                    value={contentType}
                                                    invalid={
                                                        validation.touched.contentType &&
                                                            validation.errors.contentType
                                                            ? true
                                                            : false
                                                    }
                                                    disabled={['update', 'view'].includes(pageView)}
                                                >
                                                    <option value=""></option>
                                                    <option value="html">HTML</option>
                                                    <option value="script">Script</option>
                                                </Input>
                                                {validation.touched.contentType &&
                                                    validation.errors.contentType && (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.contentType}
                                                        </FormFeedback>
                                                    )}
                                            </Col>
                                            <Col className="col-12 mb-3">
                                                <label
                                                htmlFor="category_name"
                                                className="col-md-12 col-form-label"
                                                >
                                                รายละเอียด
                                                {/* <span className="t-require">*</span> */}
                                                </label>
                                                {/* <div className="col-md-12">
                                                <MyEditor
                                                    onChange={(event, editor) => {
                                                    const data = editor.getData()
                                                    validation.setFieldValue("contentDetail", data)
                                                    }}
                                                    value={validation.values.contentDetail}
                                                    isError={validation.touched.contentDetail && validation.errors.contentDetail ? true : false}
                                                    disabled={pageView === "view"}
                                                />
                                                { 
                                                    validation.touched.contentDetail && validation.errors.contentDetail && (
                                                    <div type="invalid"className="invalid-feedback d-block">
                                                        {validation.errors.contentDetail}
                                                    </div>
                                                    )
                                                }
                                                </div> */}
                                                <div className="col-md-12">
                                                {contentType == 'html'
                                                    ? <>
                                                        <MyEditor
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData()
                                                                validation.setFieldValue("contentDetail", data)
                                                            }}
                                                            value={validation.values.contentDetail}
                                                            isError={validation.touched.contentDetail && validation.errors.contentDetail ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        {
                                                            validation.touched.contentDetail && validation.errors.contentDetail && (
                                                                <div type="invalid" className="invalid-feedback d-block">
                                                                    {validation.errors.contentDetail}
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                    : <>
                                                        <Input
                                                            id="contentDetail"
                                                            className="form-control"
                                                            type="textarea"
                                                            rows="10"
                                                            placeholder=""
                                                            name="contentDetail"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.contentDetail}
                                                            invalid={validation.touched.contentDetail && validation.errors.contentDetail ? true : false}
                                                            disabled={pageView === "view"}
                                                        />
                                                        { 
                                                            validation.touched.contentDetail && validation.errors.contentDetail && (
                                                            <FormFeedback type="invalid">
                                                                {validation.errors.contentDetail}
                                                            </FormFeedback>
                                                            )
                                                        }
                                                    </>
                                                }
                                                    
                                                </div>
                                            </Col>

                                            <Col className="col-12 mb-3">
                                            {/* {JSON.stringify(validation.values.contentFiles)} */}
                                                <div className="col-md-12">
                                                <UploadDesc
                                                    upload="PDF"
                                                    typeUpload="PDF"
                                                    label="Files"
                                                    required={false}
                                                    widthSize={600}
                                                    heightSize={250}
                                                    description="description"
                                                />
                                                <section className="b-upload-list">
                                                    <ReactSortable
                                                        list={validation.values.contentFiles} // ผูกข้อมูลกับค่าใน Formik
                                                        setList={(newState) => {
                                                            console.log('สถานะใหม่:', newState);
                                                            const newStateSort = fn_helper.FNFORM.setReSequence(newState)
                                                            validation.setFieldValue('contentFiles', newStateSort); // อัพเดตค่าฟอร์ม
                                                        }}
                                                        animation={200}
                                                        handle=".drag-handle" // จุดที่สามารถลากได้
                                                        onEnd={() => {
                                                            console.log('ลากและปล่อยเสร็จสิ้น');
                                                            // validation.validateField('contentFiles'); // ตรวจสอบความถูกต้องของฟิลด์
                                                        }}
                                                        >
                                                        <FieldArray name="contentFiles">
                                                            {({ push, remove }) => (
                                                            <>
                                                                {
                                                                validation.values.contentFiles.map((row, index) => {
                                                                    return (
                                                                    <div className="drag-handle" key={index}>
                                                                        <PopupAttachment
                                                                        typeDetail="single"
                                                                        upload="PDF"
                                                                        typeUpload="PDF"
                                                                        prefixName="files"
                                                                        label="PDF"
                                                                        mode="PdfLink"
                                                                        isShowLabel={false}
                                                                        required={false}
                                                                        description="description"
                                                                        widthSize={600}
                                                                        heightSize={250}
                                                                        value={row}
                                                                        index={index}
                                                                        onChange={(value = {}, index) => {
                                                                            console.log("🚀 onChange ~ value:", value)
                                                                            console.log("🚀 onChange ~ index:", index)
                                                                            const name = `contentFiles.${index}`
                                                                            validation.setFieldValue(name, value)
                                                                            // customHandleChange(e, index)
                                                                            // push(value)
                                                                        }}
                                                                        onRemove={(index) => {
                                                                            console.log("🚀 onChange ~ index:", index)
                                                                            remove(index)
                                                                        }}
                                                                        />
                                                                    </div>
                                                                    )
                                                                })
                                                                }
                                                                <PopupAttachment
                                                                typeDetail="single"
                                                                upload="PDF"
                                                                typeUpload="PDF"
                                                                prefixName="files"
                                                                label="PDF"
                                                                mode="PdfLink"
                                                                isAddMode={true}
                                                                isShowLabel={false}
                                                                required={false}
                                                                description="description"
                                                                widthSize={600}
                                                                heightSize={250}
                                                                index={validation.values.contentFiles.length}
                                                                onChange={(value = {}, index) => {
                                                                    console.log("🚀 onChange ~ value:", value)
                                                                    console.log("🚀 onChange ~ index:", index)
                                                                    push(value)
                                                                }}
                                                                onRemove={(index) => {
                                                                    console.log("🚀 onChange ~ index:", index)
                                                                    remove(index)
                                                                }}
                                                                />
                                                            </>
                                                            )}
                                                        </FieldArray>
                                                    </ReactSortable>
                                                </section>
                                                </div>
                                                <hr/>
                                            </Col>
                                            </>
                                        )
                                        :  (
                                        <Col className="col-12 mb-3">
                                            <label
                                            htmlFor="category_name"
                                            className="col-md-12 col-form-label"
                                            >
                                            ลิ้งค์
                                            {
                                                validation.values.contentLinks.length > 0 && (

                                                <span className="t-require">*</span>
                                                )
                                            }
                                            </label>
                                            <div className="col-md-12">
                                            <FieldArray name="contentLinks">
                                                {({ push, remove }) => (
                                                <>
                                                    {
                                                    validation.values.contentLinks.map((form, index) => {
                                                        return (
                                                            <div key={index}>
                                                            <Row>
                                                                <Col className="col-11 mb-3">
                                                                <Row>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                        >
                                                                        ชื่อนโยบายย่อย
                                                                        {/* <span className="t-require">*</span> */}
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                        <InputText
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder=""
                                                                            
                                                                            onChange={(e)=> {
                                                                            const newValue = e.target.value
                                                                            let tmpArray = _.cloneDeep(validation.values.contentLinks)
                                                                            tmpArray[index].attachmentTitle = newValue
                                                                            validation.setFieldValue('contentLinks', tmpArray)
                                                                            }}
                                                                            maxLength={9999}
                                                                            value={form.attachmentTitle}
                                                                            invalid={validation.touched.contentLinks?.[index]?.attachmentTitle && validation.errors.contentLinks?.[index]?.attachmentTitle ? true : false}
                                                                            disabled={pageView === "view"}
                                                                            errorText={validation.errors.contentLinks?.[index]?.attachmentTitle}
                                                                        />
                                                                        { 
                                                                            validation.touched.contentLinks?.[index]?.attachmentTitle && validation.errors.contentLinks?.[index]?.attachmentTitle && (
                                                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentLinks?.[index]?.attachmentTitle}</div>
                                                                            )
                                                                        }
                                                                        </div>
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                        >
                                                                        Link out
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                        <InputText
                                                                            className="form-control"
                                                                            type="text"
                                                                            placeholder=""
                                                                            onChange={(e) => {
                                                                            const newValue = e.target.value
                                                                            let tmpArray = _.cloneDeep(validation.values.contentLinks)
                                                                            tmpArray[index].attachmentAlt = newValue
                                                                            validation.setFieldValue('contentLinks', tmpArray)
                                                                            }}
                                                                            value={form.attachmentAlt}
                                                                            invalid={validation.touched.contentLinks?.[index]?.attachmentAlt && validation.errors.contentLinks?.[index]?.attachmentAlt ? true : false}
                                                                            disabled={pageView === "view"}
                                                                            maxLength={9999}
                                                                            errorText={validation.errors.contentLinks?.[index]?.attachmentAlt}
                                                                        />
                                                                        </div>
                                                                    </Col>
                                                                </Row>

                                                                </Col>
                                                                <Col className="col-1 pl-0 pt-3" style={{ paddingLeft: 0 }}>
                                                                <label
                                                                    htmlFor="category_name"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    {/* <span className="t-require">*</span> */}
                                                                </label>
                                                                <div className="">
                                                                    <Button type="button" onClick={() => {
                                                                    remove(index)
                                                                    }}>DELETE</Button>
                                                                </div>
                                                                </Col>
                                                            </Row>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                    <Button 
                                                    type="button" 
                                                    onClick={() => {
                                                    const tmp = {
                                                        attachmentField: "links",
                                                        attachmentName: "-",
                                                        attachmentRawName: "-",
                                                        attachmentType: "-",
                                                        attachmentTitle: "",
                                                        attachmentAlt: "",
                                                        attachmentExtension: "0",
                                                        attachmentSize: "0",
                                                        attachmentStatus: "active",
                                                    }
                                                    push(tmp)
                                                    }}>ADD</Button>
                                                </>
                                                )}
                                            </FieldArray>
                                            </div>
                                        </Col>
                                        )
                                    }

                                    <Col className="col-6 mb-3">
                                        {/* {JSON.stringify(validation.values.bannerDesktop)} */}
                                        <div className="col-md-12">
                                            <PopupAttachment
                                                typeDetail="single"
                                                typeUpload="ImageMap"
                                                upload="Image"
                                                prefixName="banner-desktop"
                                                label="Banner Desktop"
                                                required={true}
                                                description="description"
                                                widthSize={2160}
                                                heightSize={990}
                                                value={validation.values.bannerDesktop}
                                                onChange={(value = {}, index) => {
                                                    console.log("🚀 onChange ~ value:", value)
                                                    console.log("🚀 onChange ~ index:", index)
                                                    validation.setFieldValue('bannerDesktop', value)
                                                }}
                                                onRemove={(index) => {
                                                    console.log("🚀 onChange ~ index:", index)
                                                    validation.setFieldValue('bannerDesktop', {})
                                                }}
                                            />
                                            {validation.touched.bannerDesktop && validation.errors.bannerDesktop && (
                                                <div type="invalid" className="invalid-feedback d-block">
                                                    {validation.errors.bannerDesktop}
                                                </div>
                                            )}
                                        </div>
                                        <hr />
                                    </Col>
                                    <Col className="col-6 mb-3">
                                        {/* {JSON.stringify(validation.values.bannerMobile)} */}
                                        <div className="col-md-12">
                                            <PopupAttachment
                                                typeDetail="single"
                                                typeUpload="ImageMap"
                                                upload="Image"
                                                prefixName="banner-mobile"
                                                label="Banner Mobile"
                                                required={true}
                                                description="description"
                                                widthSize={540}
                                                heightSize={780}
                                                value={validation.values.bannerMobile}
                                                onChange={(value = {}, index) => {
                                                    console.log("🚀 onChange ~ value:", value)
                                                    console.log("🚀 onChange ~ index:", index)
                                                    validation.setFieldValue('bannerMobile', value)
                                                }}
                                                onRemove={(index) => {
                                                    console.log("🚀 onChange ~ index:", index)
                                                    validation.setFieldValue('bannerMobile', {})
                                                }}
                                            />
                                             {validation.touched.bannerDesktop && validation.errors.bannerDesktop && (
                                                <div type="invalid" className="invalid-feedback d-block">
                                                    {validation.errors.bannerDesktop}
                                                </div>
                                            )}
                                        </div>
                                        <hr />
                                    </Col>
                                </Row>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col className="col-4">
                            <Card outline color="primary" className="border sticky-element">
                                <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                <i className='bx bx-check'></i> Tools Box
                                </h5>
                                <CardBody>
                                <Row>
                                    <Col className="col-12 mb-3">
                                    <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                    >
                                        Switch Language
                                        <span className="t-require">*</span>
                                    </label>
                                    <div className="col-md-12">
                                        <InputLang widthfull pageView={pageView} forceRoute={false}/>
                                    </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                    <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                    >
                                        Written at
                                        <span className="t-require">*</span>
                                    </label>
                                    <div className="col-md-12">
                                        <InputGroup>
                                        <Flatpickr
                                            className="form-control d-block"
                                            options={{
                                            dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                            }}
                                            value={validation.values.contentUpdateDate  ?moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                            disabled={true}
                                        />
                                        <div className="input-group-append">
                                            <button
                                            type="button"
                                            className="btn btn-outline-secondary docs-datepicker-trigger"
                                            disabled
                                            >
                                            <i className="fa fa-calendar" aria-hidden="true"/>
                                            </button>
                                        </div>
                                        </InputGroup>
                                        {
                                        (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                        )
                                        }
                                    </div>
                                    </Col>
                                    <Col className="col-12 mb-3">
                                    <label
                                        htmlFor="category_name"
                                        className="col-md-12 col-form-label"
                                    >
                                        Display
                                        <span className="t-require">*</span>
                                    </label>
                                    <div className="col-md-12">
                                        <Select
                                        placeholder="Select Status"
                                        value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                        onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                        getOptionValue={(option) => option.id}
                                        getOptionLabel={(option) => option.name}
                                        options={STATUS_OPTION}
                                        className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}` }
                                        isDisabled={pageView === "view"}
                                        />
                                        {
                                        (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                        )
                                        }
                                    </div>
                                    </Col>
                                </Row>
                                </CardBody>
                                <CardFooter>
                                <Row>
                                    <Col className="text-start">
                                        <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/pdpa/privacy-notice/${qLang}`)}>Back</Button>
                                    </Col>
                                    <Col className="text-end">
                                        {pageView !== 'view' && (<Button type="submit" className="btn btn-success">Save</Button>)}
                                    </Col>
                                </Row>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col className="col-12">
                        <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                <i className='bx bx-trending-up'></i> SEO Box
                            </h5>
                            <CardBody>
                            <Row className="">
                                <Col className="col-12 mb-3">
                                <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                >
                                    Meta Title
                                    <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                    <InputText
                                        id="contentSeoTitle"
                                        className="form-control"
                                        type="text"
                                        placeholder="Page Title"
                                        name="contentSeoTitle"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoTitle}
                                        invalid={validation.touched.contentSeoTitle && validation.errors.contentSeoTitle ? true : false}
                                        disabled={pageView === "view"}
                                        maxLength={9999}
                                        errorText={validation.errors.contentSeoTitle}
                                    />
                                </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                >
                                    Meta Description
                                    {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                    <InputText
                                        id="contentSeoDescription"
                                        className="form-control"
                                        type="text"
                                        placeholder="SEO Description"
                                        name="contentSeoDescription"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoDescription}
                                        invalid={validation.touched.contentSeoDescription && validation.errors.contentSeoDescription ? true : false}
                                        disabled={pageView === "view"}
                                        maxLength={9999}
                                        errorText={validation.errors.contentSeoDescription}
                                    />
                                </div>
                                </Col>
                                <Col className="col-12 mb-3">
                                <label
                                    htmlFor="category_name"
                                    className="col-md-12 col-form-label"
                                >
                                    Meta Keywords
                                    {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                    <InputText
                                        id="contentSeoKeyword"
                                        className="form-control"
                                        type="text"
                                        placeholder="SEO Keywords"
                                        name="contentSeoKeyword"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.contentSeoKeyword}
                                        invalid={validation.touched.contentSeoKeyword && validation.errors.contentSeoKeyword ? true : false}
                                        disabled={pageView === "view"}
                                        maxLength={9999}
                                        errorText={validation.errors.contentSeoKeyword}
                                    />
                                </div>
                                </Col>
                            </Row>
                            </CardBody>
                        </Card>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                  </Col>
                </Row>
            </Container>
          </div>
      </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(PrivacyNoticeTemplate)
